import { ButtonVariants } from '~/components/atoms/Button/Button'
import { gutterTypes } from '~/components/atoms/Container/Container'
import { TextSizes } from '~/components/atoms/Text/Text'

export enum componentType {
  singleColumn = 'singleColumn',
  twoColumn = 'twoColumn',
  hero = 'hero',
  categoryImageFullWidth = 'categoryImageFullWidth',
  categoryImageContained = 'categoryImageContained',
  categoryImageContainedMagazine = 'categoryImageContainedMagazine',
  categoryImageFullWidthMagazine = 'categoryImageFullWidthMagazine',
}

export const componentTypes: any = {
  [componentType.singleColumn]: {
    styles: ['col-1/2--md', 'col-1/2--md'],
    title: TextSizes.primaryTitleLrg,
    pretitle: TextSizes.primaryTitleMed,
    subtitle: TextSizes.secondaryTitleLrg,
    gutters: gutterTypes.upToSmall,
    button: {
      variant: ButtonVariants.secondaryDark,
      inline: true,
      iconLeft: true,
    },
    container: 'noMaxWidth',
  },
  [componentType.twoColumn]: {
    styles: ['col-1/4--md', 'col-3/4--md'],
    title: TextSizes.primaryTitleLrg,
    pretitle: TextSizes.primaryTitleMed,
    subtitle: undefined,
    gutters: gutterTypes.always,
    button: {
      variant: undefined,
      inline: undefined,
      iconLeft: undefined,
    },
    container: '',
  },
  [componentType.hero]: {
    styles: ['col-1/2--md', 'col-1/2--md'],
    title: TextSizes.primaryTitleXLrg,
    pretitle: undefined,
    subtitle: TextSizes.secondaryTitleLrg,
    gutters: gutterTypes.never,
    button: {
      variant: ButtonVariants.primaryDark,
      inline: false,
      iconLeft: true,
    },
    container: 'noMaxWidth',
  },
  [componentType.categoryImageFullWidth]: {
    styles: ['col-1/2--md', 'col-1/2--md'],
    title: TextSizes.primaryTitleMed,
    pretitle: undefined,
    subtitle: TextSizes.primaryTitleLrgPlus,
    gutters: gutterTypes.upToMedium,
    button: {
      variant: ButtonVariants.primaryDark,
      inline: false,
      iconLeft: true,
    },
    container: 'noMaxWidth',
  },
  [componentType.categoryImageContained]: {
    styles: ['col-1/2--md', 'col-1/2--md'],
    title: TextSizes.primaryTitleMed,
    pretitle: undefined,
    subtitle: TextSizes.primaryTitleLrgPlus,
    gutters: gutterTypes.always,
    button: {
      variant: ButtonVariants.primaryDark,
      inline: false,
      iconLeft: true,
    },
    container: '',
  },
  [componentType.categoryImageFullWidthMagazine]: {
    styles: ['col-1/2--md', 'col-1/2--md'],
    title: TextSizes.primaryTitleMed,
    pretitle: undefined,
    subtitle: TextSizes.magSecondaryTitleLrg,
    gutters: gutterTypes.upToMedium,
    button: {
      variant: ButtonVariants.primaryDark,
      inline: false,
      iconLeft: true,
    },
    container: 'noMaxWidth',
  },
  [componentType.categoryImageContainedMagazine]: {
    styles: ['col-1/2--md', 'col-1/2--md'],
    title: TextSizes.primaryTitleMed,
    pretitle: undefined,
    subtitle: TextSizes.magSecondaryTitleLrg,
    gutters: gutterTypes.always,
    button: {
      variant: ButtonVariants.primaryDark,
      inline: false,
      iconLeft: true,
    },
    container: '',
  },
}
